module.exports = __webpack_public_path__ + "static/media/whiskey-bottle.71d51704.svg";